export enum ChartView {
  RIGHT_SWIPES_RESPONSE_RATE,
  CHRONOLOGICAL,
}
